import { StackedBarChartRoundedTopBar } from './StackedBarChartRoundedTopBar';
import type { BarProps } from '@mui/x-charts/BarChart';

type BarChartRoundedTopBarProps = BarProps & {
  barRadius: number;
  topSeriesKeyByRow: Array<string | null>;
};

export const BarChartRoundedTopBar = (props: BarChartRoundedTopBarProps): JSX.Element => (
  <StackedBarChartRoundedTopBar
    {...props}
    segmentSeparatorColor="transparent"
    segmentSeparatorOpacity={0}
    segmentSeparatorWidth={0}
  />
);
